import styled from 'styled-components';

export const Img = styled.img`
  width: 100%;
  display: block;
`;
